import axios, { AxiosInstance, AxiosError, AxiosResponse } from "axios";

const axiosClient = (): AxiosInstance => {

  const client = axios.create({
    baseURL: "http://localhost:8080/v1",
    headers: { "Content-Type": "application/json" },
    timeout: 60000,
    withCredentials: false,
  });

  client.interceptors.request.use((config: any) => {
    const token = localStorage.getItem("token");
    config.headers = config.headers || {};
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  client.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    (error: AxiosError) => {
      try {
        const { response } = error;
        if (response?.status === 401) {
          localStorage.removeItem("token");
        } else if (response?.status === 500) {
          alert("Something wrong!");
        }
      } catch (e) {
        console.error(e);
        if (error.response?.status === 500) {
          alert("Something wrong!");
        }
      }
      throw error;
    },
  );

  return client;
};

export default axiosClient;



